import { observer } from 'mobx-react';
import * as React from 'react';

import { ProgressManager } from './ProgressManager';

import App from '@egr/xbox/base-app/App';
import { LoadingCircle } from '@egr/xbox/egr-gui-elements/LoadingAnimation/LoadingCircle';

interface LoadingTileProps {
    app?: App;
    modal: boolean;
    hide?: boolean;
    color?: 'primary' | 'secondary' | 'inherit';
    withTransition?: boolean;
}

@observer
export class LoadingTile<Props extends LoadingTileProps = LoadingTileProps> extends React.Component<Props> {
    public override render(): React.ReactNode {
        if (this.props.hide || this.props.app?.dialogManager.dialogVisible) {
            return null;
        }

        return (
            <LoadingCircle
                withTransition={this.props.withTransition}
                color={this.props.color}
                show={ProgressManager.inProgress}
                modal={this.props.modal}
                size={40}
            />
        );
    }
}
